// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { FactoryEditor_abstract } from './../abstract/SagaBase/FactoryEditor_abstract';
export class FactoryEditor extends FactoryEditor_abstract {}
